module.exports = __webpack_public_path__ + "img/Norfolk-Island.6f3ecbe0.png";